import {
    ProductPriceType,
    ProductWithAddOns
} from 'components/enrollForm/enrollFormTypes'

export type ProductListDisplayInfo = {
    isMultiSize: boolean
    sizeDisplay?: string
    listPrice?: number
    hidePrice: boolean
}

export const isStandalonePrice = (productPrice: ProductPriceType) =>
    !productPrice.depends_on || productPrice.depends_on.length === 0

export const getStandalonePrices = (
    product: Pick<Partial<ProductWithAddOns>, 'product_prices'>
): ProductPriceType[] =>
    (product.product_prices || []).filter(isStandalonePrice)

/** Standalone (non-add-on) price, else the first price on the product. */
export const getDisplayPackagePrice = (
    product: Pick<Partial<ProductWithAddOns>, 'product_prices'>
): ProductPriceType | undefined => {
    const prices = product.product_prices || []
    return getStandalonePrices(product)[0] || prices[0]
}

export const getProductListDisplayInfo = (
    product: Partial<ProductWithAddOns>
): ProductListDisplayInfo => {
    const standalonePrices = getStandalonePrices(product)
    const isMultiSize = standalonePrices.length > 1
    const hidePrice = Boolean(product.hide_price)

    if (isMultiSize) {
        return { isMultiSize: true, hidePrice }
    }

    const displayPrice = getDisplayPackagePrice(product)

    return {
        isMultiSize: false,
        sizeDisplay: displayPrice?.package_size_display,
        listPrice: displayPrice?.price,
        hidePrice
    }
}
